import { useQuery } from '@tanstack/react-query';

import TaxonomiesService from '@/services/TaxonomiesService';

const GET_ADMIN_TAXONOMIES_BY_CATEGORY_QUERY_KEY = (
  customerId: number,
  version: string,
  category: string,
) => ['admin-taxonomies-by-category', customerId, version, category];
export function useGetAdminTaxonomiesByCategories(
  customerId: number,
  version: string,
  category: string,
) {
  const { data, isFetching } = useQuery({
    queryKey: GET_ADMIN_TAXONOMIES_BY_CATEGORY_QUERY_KEY(
      customerId,
      version,
      category,
    ),
    queryFn: () =>
      TaxonomiesService.getAdminTaxonomyPropertiesByVersionAndCategory(
        customerId,
        version,
        category,
      ),
    enabled: !!category && !!version,
  });

  return {
    taxonomies: data ?? [],
    isLoading: isFetching,
  };
}
